import { Box, keyframes, styled, SxProps } from '@mui/material';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
`;

const Dot = styled('span')<{ delay: number }>(({ delay }) => ({
  display: 'inline-block',
  width: '4px',
  height: '4px',
  margin: '0 2px',
  backgroundColor: 'currentColor',
  borderRadius: '50%',
  animation: `${pulse} 1.4s ease-in-out ${delay}s infinite`,
}));

export const Loading = ({ sx }: { sx?: SxProps }) => {
  return (
    <Box sx={{ display: 'flex', flex: 1, alignItems: 'baseline', fontSize: '1.25rem', ...sx }}>
      Loading
      <Dot delay={0} />
      <Dot delay={0.2} />
      <Dot delay={0.4} />
    </Box>
  );
};
